import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useIncomeForms, FORM_IDS } from './useIncomeForms';
import { CashFlowForm } from './CashFlowForm';
import { RentalForm } from './RentalForm';
import { SavedWorksheets } from './SavedWorksheets';

// ============================================================================
// IncomeFormsCard — Fannie Mae Form 1084, Freddie Mac Form 91 and Form 92
// worksheets (ticket 215). Definitions, labels and versions come from the backend.
// ============================================================================
export function IncomeFormsCard() {
  const [open, setOpen] = useState(false);
  const ctl = useIncomeForms({ enabled: open });
  const def = ctl.defs?.[ctl.tab];

  return (
    <div className="rounded-2xl border border-slate-200 shadow-sm bg-white overflow-hidden" data-testid="income-forms-card">
      <button
        onClick={() => setOpen(!open)}
        className="w-full px-5 py-4 flex items-center justify-between hover:bg-slate-50 transition"
        data-testid="toggle-income-forms"
      >
        <div className="text-left">
          <div className="text-[11px] uppercase tracking-widest font-bold text-brand-accent">Income Forms</div>
          <div className="font-serif text-base font-semibold text-brand-navy">
            Form 1084, Form 91 and Form 92 worksheets
          </div>
        </div>
        <ChevronDown size={18} className={`text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="border-t border-slate-100 p-5 space-y-4">
          <div className="flex gap-2">
            {FORM_IDS.map((id) => (
              <button
                key={id}
                onClick={() => ctl.setTab(id)}
                className={`px-3 py-1.5 rounded-md text-xs font-semibold ${ctl.tab === id ? 'bg-brand-navy text-white' : 'bg-slate-100 text-slate-600'}`}
                data-testid={`income-form-tab-${id}`}
              >Form {id}</button>
            ))}
          </div>

          {ctl.defsError && <div className="text-sm text-red-600" data-testid="income-forms-error">{ctl.defsError}</div>}
          {!def && !ctl.defsError && <div className="text-sm text-slate-500">Loading the forms…</div>}
          {def && (def.kind === 'rental'
            ? <RentalForm key={ctl.tab} formId={ctl.tab} def={def} ctl={ctl} />
            : <CashFlowForm key={ctl.tab} formId={ctl.tab} def={def} ctl={ctl} />)}

          <SavedWorksheets
            worksheets={ctl.worksheets}
            onOpen={ctl.open}
            onDownload={ctl.download}
            onDelete={ctl.remove}
          />
        </div>
      )}
    </div>
  );
}
